<template>
	<div>
		<page-title-bar></page-title-bar>
		<v-container fluid grid-list-xl pt-0>
			<v-layout row wrap justify-center>
				<v-flex xs12>
                    <v-tabs grow>
                        <v-tab>
                            <h4 class="mb-0">Phiếu chưa xử lý</h4>
                        </v-tab>
                        <v-tab>
                            <h4 class="mb-0">Phiếu thu Chủ Trọ</h4>
                        </v-tab>
                    </v-tabs>
					<app-card>
						<v-toolbar flat color="white">
							<v-toolbar-title>BẢNG PHIẾU THU CHỦ TRỌ</v-toolbar-title>
							<v-spacer></v-spacer>
							<v-btn @click="dialog = !dialog" color="green" dark>Tạo Phiếu Mới</v-btn>
						</v-toolbar>
						<v-container class="pt-3" fluid grid-list-xl>
							<v-layout row>
								<v-spacer></v-spacer>
								<v-flex xs12 md3 class="pa-0">
									<v-menu
										:close-on-content-click="false"
										v-model="menu_date_start"
										:nudge-right="40"
										lazy
										transition="scale-transition"
										offset-y
										full-width
										min-width="290px"
									>
										<v-text-field
											slot="activator"
											v-model="date_start"
											label="Ngày bắt đầu"
											:disabled="loading.submit"
											prepend-icon="event"
											readonly
										></v-text-field>
										<v-date-picker locale="vi-VI" v-model="date_start" @input="menu_date_start = false"></v-date-picker>
									</v-menu>
								</v-flex>
								<v-flex xs12 md3 class="pa-0">
									<v-menu
										:close-on-content-click="false"
										v-model="menu_date_end"
										:nudge-right="40"
										lazy
										transition="scale-transition"
										offset-y
										full-width
										min-width="290px"
									>
										<v-text-field
											slot="activator"
											v-model="date_end"
											label="Ngày kết thúc"
											:disabled="loading.submit"
											prepend-icon="event"
											readonly
										></v-text-field>
										<v-date-picker locale="vi-VI" v-model="date_end" @input="menu_date_end = false"></v-date-picker>
									</v-menu>
								</v-flex>
							</v-layout>
							<v-layout row justify-end>
								<v-flex xs12 md3>
									<v-select
										label="Tòa nhà"
										:disabled="loading.submit"
										v-model="chosen_building"
										:items="list_building"
										prepend-icon="domain"
										required
										single-line
										hide-details
									></v-select>
								</v-flex>
								<v-flex xs12 md3>
									<v-text-field
										v-model="search"
										prepend-icon="search"
										label="Tìm kiếm"
										single-line
										hide-details
									></v-text-field>
								</v-flex>
								<v-flex xs12 md3>
									<v-select
										label="Tìm theo"
										:disabled="loading.submit"
										v-model="search_type"
										:items="list_search_type"
										prepend-icon="visibility"
										required
										single-line
										hide-details
									></v-select>
								</v-flex>
								<v-flex xs12 md3 class="pb-0">
									<v-btn @click="getData" color="primary" dark class="mt-3 mb-0">Tìm kiếm</v-btn>
								</v-flex>
							</v-layout>
						</v-container>
						<app-section-loader :status="loader"></app-section-loader>
						<v-data-table :headers="headers" :items="items" item-key="id">
							<template #headers="props">
								<tr>
									<th
										:class="['fw-bold', `text-xs-${header.align}`]"
										v-for="header in props.headers"
										:key="header.text"
									>{{ header.text }}</th>
								</tr>
							</template>
							<template #items="props">
								<tr>
									<td class="text-center text-no-wrap">{{ props.item.date_collected }}</td>
									<td class="text-center text-no-wrap">{{ props.item.id }}</td>
									<td class="text-center text-no-wrap">{{ props.item.receipt_count }}</td>
									<td class="text-center text-no-wrap">{{ props.item.total_amount_collected }}</td>
									<td class="text-center text-no-wrap">{{ props.item.accum }}</td>
									<!-- <td class="text-center text-no-wrap">
                                        <v-btn flat icon color="primary" @click="onDeleteCartItem(props.item)">
                                            <v-icon class="zmdi zmdi-edit"></v-icon>
                                        </v-btn>
									</td>-->
								</tr>
							</template>
							<template #no-data>Chưa có thông tin</template>
						</v-data-table>
					</app-card>
				</v-flex>
			</v-layout>
		</v-container>
		<v-dialog v-model="dialog" max-width="100%">
			<app-card>
				<h4>TẠO PHIẾU THU CỦA CHỦ TRỌ</h4>
				<p class="fs-14 grey--text">Tạo phiếu thu tiền phòng, phiếu thu tiền cọc</p>
				<v-form>
					<v-container fluid>
						<v-layout row wrap>
							<v-flex xs12 md3>
								<v-text-field
									label="Số Chứng Từ Chủ Trọ"
									:disabled="loading.submit"
									type="text"
									v-model="form.receipt_id"
									prepend-icon="book"
									required
								></v-text-field>
							</v-flex>
							<v-flex xs12 md3>
								<v-menu
									:close-on-content-click="false"
									v-model="menu_date_collected"
									:nudge-right="40"
									lazy
									transition="scale-transition"
									offset-y
									full-width
									min-width="290px"
								>
									<v-text-field
										slot="activator"
										v-model="form.date_collected"
										label="Ngày thu"
										:disabled="loading.submit"
										prepend-icon="event"
										readonly
									></v-text-field>
									<v-date-picker
										locale="vi-VI"
										v-model="form.date_collected"
										@input="menu_date_collected = false"
									></v-date-picker>
								</v-menu>
							</v-flex>
							<!-- <v-flex xs12 md3>
                                <v-select
                                    label="Người thu"
                                    :disabled="loading.submit"
                                    v-model="form.collector"
                                    :items="list_final_collectors"
                                    required
                                    type="text"
                                    prepend-icon="person"
                                ></v-select>
							</v-flex>-->
							<v-flex xs12 md3>
								<v-text-field
									label="Số phiếu lượng phiếu chi tiết"
									type="number"
									min="1"
									max="20"
									v-model.number="form.receipt_count"
									@change="changeReceptCount"
									:disabled="loading.submit"
									prepend-icon="bookmarks"
								></v-text-field>
							</v-flex>
							<v-flex xs12 md3>
								<v-text-field
									:label="`Số tiền Chủ Trọ thu`"
									v-model="form.total_amount_collected"
									prepend-icon="attach_money"
									required
								></v-text-field>
							</v-flex>
							<v-card width="100%">
								<v-toolbar color="blue lighten-1" dark>
									<v-toolbar-title>Các phiếu chi tiết</v-toolbar-title>
									<v-spacer></v-spacer>
									<!-- <v-btn @click="() => { form.receipts.push({}); calTotalAmount() }" icon>
                                        <v-icon>add</v-icon>
                                    </v-btn>
                                    <v-btn @click="() => { form.receipts.pop(); calTotalAmount() }" icon>
                                        <v-icon>remove</v-icon>
									</v-btn>-->
								</v-toolbar>
								<v-container class="pt-0" fluid>
									<template v-for="(receipt, index) in form.receipts">
										<h4 class="mt-4" :key="`receipt ${index + 1}`">Phiếu #{{index + 1}}</h4>
										<v-layout :key="`row receipt ${index + 1}`" row wrap justify-content-start>
											<v-flex xs12 md3>
												<v-select
													label="Loại phiếu"
													:disabled="loading.submit"
													v-model="receipt.type"
													:items="list_type"
													prepend-icon="book"
													required
												></v-select>
											</v-flex>
											<v-flex xs12 md3>
												<v-select
													label="Tòa nhà"
													:disabled="loading.submit"
													v-model="receipt.building"
													:items="list_building"
													prepend-icon="domain"
													required
													single-line
													hide-details
												></v-select>
											</v-flex>
											<v-flex xs12 md3>
												<v-select
													label="Số phòng"
													:disabled="loading.submit"
													v-model="receipt.room_id"
													:items="rooms.filter( room => room.building === receipt.building)"
													item-text="room_id"
													item-value="rooms_id"
													prepend-icon="meeting_room"
													required
													@change="findReceiptPayment(receipt)"
												></v-select>
											</v-flex>
											<v-flex v-if="receipt.type === 'PAYMENT'" xs12 md3>
												<v-menu
													:close-on-content-click="false"
													v-model="receipt_data_month[index]"
													:nudge-right="40"
													lazy
													transition="scale-transition"
													offset-y
													full-width
													min-width="290px"
												>
													<v-text-field
														slot="activator"
														v-model="receipt.month"
														label="Chọn tháng"
														:disabled="loading.submit"
														prepend-icon="event"
														readonly
													></v-text-field>
													<v-date-picker
														min="2019-10"
														locale="vi-VI"
														type="month"
														v-model="receipt.month"
														@change="findReceiptPayment(receipt)"
														@input="receipt_data_month[index] = false"
													></v-date-picker>
												</v-menu>
											</v-flex>
											<v-flex xs12 md3>
												<v-text-field
													:label="`Mã phiếu #${index + 1}`"
													:disabled="loading.submit"
													v-model="receipt.id"
													@change="findReceiptDeposit(receipt)"
													prepend-icon="label"
													required
												></v-text-field>
											</v-flex>
											<v-flex xs12 md3>
												<v-menu
													:close-on-content-click="false"
													v-model="receipt_date_collected[index]"
													:nudge-right="40"
													lazy
													transition="scale-transition"
													offset-y
													full-width
													min-width="290px"
												>
													<v-text-field
														slot="activator"
														v-model="receipt.date_collected_string"
														label="Ngày thu"
														:disabled="loading.submit"
														prepend-icon="event"
														readonly
													></v-text-field>
													<v-date-picker
														locale="vi-VI"
														v-model="receipt.date_collected_string"
														@input="receipt_date_collected[index] = false"
													></v-date-picker>
												</v-menu>
											</v-flex>
											<v-flex xs12 md3>
												<v-text-field
													:label="`Số tiền #${index + 1}`"
													:disabled="loading.submit"
													v-model="receipt.amount"
													@change="formatMoney(receipt)"
													prepend-icon="money"
													required
												></v-text-field>
											</v-flex>
											<v-flex xs12 md3>
												<v-select
													label="Người thu"
													:disabled="loading.submit"
													v-model="receipt.collector"
													:items="list_first_collectors"
													required
													type="text"
													prepend-icon="domain"
												></v-select>
											</v-flex>
											<v-flex xs12 md3>
												<v-text-field
													label="Ghi chú"
													:disabled="loading.submit"
													v-model="receipt.note"
													prepend-icon="event_note"
												></v-text-field>
											</v-flex>
										</v-layout>
										<!-- <hr v-if="index < form.receipts.length - 1" :key="`hr ${index}`"> -->
									</template>
								</v-container>
							</v-card>
						</v-layout>
					</v-container>
					<v-card-actions>
						<v-spacer></v-spacer>
						<span :class="['mr-3', is_amount_eq ? 'green--text' : ' red--text']">
							Số tiền Chủ Trọ thu: {{ form.total_amount_collected }}
							| Số tiền nhập từ chứng từ bv: {{ total_receipt_amount | formatNumber}}
						</span>
						<v-btn
							:loading="loading.submit"
							:disabled="loading.submit || !is_amount_eq"
							@click="submit"
							color="primary"
						>Tạo Phiếu</v-btn>
					</v-card-actions>
					<!-- <v-btn @click="clear" color="primary">{{$t("message.clear")}}</v-btn> -->
				</v-form>
			</app-card>
		</v-dialog>
	</div>
</template>
<script>
import moment from "moment";
import {
	buildParamQuery,
	formatTimeServer,
	deepCopy
} from "../../helpers/helpers.js";
import api from "../../api";
import { list_building } from '../../constants/db-config'

export default {
	data() {
		return {
			dialog: false,
			form: {
				receipt_id: "",
				date_collected: new Date().toISOString().substr(0, 10),
				// collector: '',
				receipt_count: 2,
				receipts: [{}, {}],
				total_amount_collected: 0
			},
			menu_date_collected: false,
			loader: true,
			headers: [
				{ text: "Ngày thu", align: "center", sortable: false },
				{
					text: "#Chứng từ",
					align: "center",
					sortable: false,
					value: "id"
				},
				{ text: "Số lượng", align: "center", sortable: false },
				{ text: "Chi tiết", align: "center", sortable: false },
				{ text: "Thu", align: "center", sortable: false },
				{ text: "Chi", align: "center", sortable: false },
				{ text: "Tổng cộng", align: "center", sortable: false }
				// { text: "Ghi chú", align: "center", sortable: false, },
				// { text: "Điều chỉnh", align: "center", sortable: false  }
			],
			items: [],
			loading: {
				submit: false
			},
			list_type: [
				{ text: "Tiền cọc", value: "DEPOSIT" },
				{ text: "Tiền phòng", value: "PAYMENT" }
			],
			// list_final_collectors: [
			//     { text: 'Trung Sơn', value: 'trungson'},
			//     { text: 'Sơn Trung', value: 'sontrung'}
			// ],
			list_first_collectors: [
				{ text: "BVBN", value: "BVBN" },
				{ text: "BVGB", value: "BVGB" },
				{ text: "BVTT", value: "BVTT" },
				{ text: "BVXA", value: "BVXA" },
				{ text: "BVMA", value: "BVMA" },
				{ text: "BVBMT", value: "BVBMT" }
			],
            list_building: [
                ...list_building,
            ],
			receipt_date_collected: [],
			receipt_data_month: [],
			chosen_building: "BN",
			list_search_type: [
				{ text: "Số phòng", value: "roomId" },
				{ text: "Mã số phiếu", value: "receiptId" },
				{ text: "Mã quản lý", value: "roomStateId" },
				{ text: "Tên khách hàng", value: "name" }
			],
			rowPerPage: [20, 50, 100, { text: "Tất cả", value: -1 }],
			menu_date_start: false,
			menu_date_end: false,
			date_start: moment()
				.startOf("month")
				.format("YYYY-MM-DD"),
			date_end: new Date().toISOString().substr(0, 10),
			search: "",
			search_type: "roomId",
			total_receipt_amount: 0,
			is_amount_eq: false
		};
	},
	computed: {
		rooms() {
			return this.$store.state.app.rooms;
		}
	},
	watch: {
		"form.total_amount_collected": function(nv, ov) {
			this.form.total_amount_collected = nv
				? nv
						.toString()
						.replace(/,/g, "")
						.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
				: 0;
			this.is_amount_eq =
				this.total_receipt_amount &&
				Number(nv.toString().replace(/,/g, "")) &&
				Number(nv.toString().replace(/,/g, "")) ==
					this.total_receipt_amount;
		},
		total_receipt_amount() {
			this.is_amount_eq =
				this.total_receipt_amount &&
				Number(
					this.form.total_amount_collected
						.toString()
						.replace(/,/g, "")
				) &&
				Number(
					this.form.total_amount_collected
						.toString()
						.replace(/,/g, "")
				) == this.total_receipt_amount;
		}
		// 'form.receipt_count'(nv){
		//     this.form.receipt_count = nv > 5 ? 5 : nv < 1 ? 1 : this.form.receipt_count
		// },
	},
	created() {
		this.getData();
	},
	mounted() {},
	methods: {
		clearInput() {
			(this.form = {
				receipt_id: "",
				date_collected: new Date().toISOString().substr(0, 10),
				collector: "",
				receipt_count: 2,
				receipts: [{}, {}],
				total_amount_collected: 0
			}),
				(this.total_receipt_amount = 0);
		},
		formatMoney: function(receipt) {
			let amount = receipt.amount;
			amount = amount
				? amount
						.toString()
						.replace(/,/g, "")
						.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
				: 0;
			receipt.amount = amount;
			this.calTotalAmount();
		},
		calTotalAmount: function() {
			let total_amount_collected = 0;
			this.form.receipts.forEach(receipt =>
				receipt.amount
					? (total_amount_collected += Number(
							receipt.amount.replace(/,/g, "")
					  ))
					: null
			);
			this.total_receipt_amount = total_amount_collected;
		},
		changeReceptCount: function() {
			if (this.form.receipts.length < this.form.receipt_count) {
				let diff = this.form.receipt_count - this.form.receipts.length;
				for (let i = 0; i < diff; i++) this.form.receipts.push({});
			} else if (this.form.receipts.length > this.form.receipt_count) {
				let diff = -this.form.receipt_count + this.form.receipts.length;
				for (let i = 0; i < diff; i++) this.form.receipts.pop();
			}
		},
		validate: function() {
			return true;
		},
		submit: async function() {
			if (!this.validate()) {
				return;
			}
			this.loading.submit = true;
			let postData = { ...this.form };
			postData.date_collected = new Date(postData.date_collected);
			postData.receipts = deepCopy(
				this.form.receipts.filter(receipt => receipt.id)
			);
			postData.receipts.forEach(receipt => {
				receipt.amount = Number(receipt.amount.replace(/,/g, ""));
				receipt.date_collected = new Date(
					receipt.date_collected_string
				);
			});
			postData.total_amount_collected = Number(
				postData.total_amount_collected.replace(/,/g, "")
			);
			let data = await api.createReceiptCollected(postData);
			if (data.status === 200) {
				(this.dialog = false), this.clearInput();
				swal.fire("Thành công", "Tạo phiếu thu thành công", "success");
			} else {
				swal.fire("Lỗi", data.message, "error");
			}
			this.loading.submit = false;
		},
		getData: async function() {
			this.items = [];
			this.loader = true;
			this.items = [];
			this.loader = false;
		},
		resetState: async function() {
			this.form = {
				id: "21",
				date_collected: new Date().toISOString().substr(0, 10),
				collector: "",
				receipt_count: 3,
				receipts: [{}, {}, {}],
				total_amount_collected: 0
			};
		},
		findReceiptPayment: async function(receipt) {
			if (!receipt.room_id || !receipt.month) {
				return;
			}
			const params = {
				roomId: receipt.room_id,
				month: receipt.month
			};
			const query = buildParamQuery(params);
			const data = await api.findPayment(query);
			if (data.status === 200 && data.data) {
				receipt.amount = data.data.total_bill;
				receipt.room_state_id = data.data.room_state_id;
				this.formatMoney(receipt);
			}
		},
		findReceiptDeposit: async function(receipt) {
			if (receipt.type !== "DEPOSIT") return;
			const params = {
				receiptId: receipt.id
			};
			const query = buildParamQuery(params);
			const data = await api.getDepositReceipts(query);
			if (data.status == 200 && data.data.length) {
				const deposit_data = data.data[0];
				receipt.date_collected_string = deposit_data.date_deposit.substr(
					0,
					10
				);
				receipt.amount = deposit_data.deposit_amount;
				this.formatMoney(receipt);
			}
		}
	}
};
</script>
